<div class="animate-pulse border bg-neutral-300 rounded-md p-4 max-w-sm w-full mx-auto"></div>
